module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-1-photo-2-ee2a4b5ca24b33a80ec48b1ee062b9e3.webp";